import { Component, EventEmitter, Injector, Input, Output } from '@angular/core';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { AppComponentBase } from '@shared/app-component-base';
import { ClinicaMedicaConvenioDto, ClinicaMedicaConvenioServiceProxy, ConvenioDto, ProfissionalSaudeConvenioDto, ProfissionalSaudeConvenioServiceProxy, TipoUsuarioEnum, UpdateConvenioDto } from '@shared/service-proxies/service-proxies';
import { StringExtensionService } from '@shared/services/string-extension.service';
import { CreateConvenioComponent } from './create-convenio/create-convenio.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { EditConvenioComponent } from './edit-convenio/edit-convenio.component';
import { SuspendConvenioComponent } from './suspend-convenio/suspend-convenio.component';
import { ActiveConvenioComponent } from './active-convenio/active-convenio.component';
import { finalize } from '@node_modules/rxjs/operators';

@Component({
  selector: 'app-default-convenios',
  templateUrl: './default-convenios.component.html',
  styleUrls: ['./default-convenios.component.scss'],
  animations: [appModuleAnimation()]
})
export class DefaultConveniosComponent extends AppComponentBase {

  public status: boolean = undefined;
  public modalidade: boolean = undefined;
  public nameOrCnpj: string;
  @Input() convenios: ConvenioDto[] = [];
  @Input() isAdmin: boolean = false;
  @Input() isClinica: boolean = false;
  @Input() isProfissional: boolean = false;
  @Input() pageSize: number;
  @Input() pageNumber: number;
  @Input() totalItems: number;
  @Output() onRefresh = new EventEmitter<any>();
  @Output() onGetDataPage = new EventEmitter<any>();
  @Output() onStatus = new EventEmitter<boolean>();
  @Output() onModalidade = new EventEmitter<boolean>();
  @Output() onNameOrCnpj = new EventEmitter<string>();

  constructor(
    injector: Injector,
    public stringService: StringExtensionService,
    private _modalService: BsModalService,
    private readonly _clinicaConvenioService: ClinicaMedicaConvenioServiceProxy,
    private readonly _profissionalConvenio: ProfissionalSaudeConvenioServiceProxy,
  ) {
    super(injector);
  }

  protected create(): void {
    const createModal = this._modalService.show(
      CreateConvenioComponent,
      {
        class: 'modal-md',
        ignoreBackdropClick: true,
      }
    );

    createModal.content.onSave.subscribe((convenio: ConvenioDto) => {
      abp.notify.success("Convênio cadastrado com sucesso!");
      this.createVinculo(convenio);
      this.onRefresh.emit();
    });
  }

  protected edit(entity: ConvenioDto): void {
    const editModal = this._modalService.show(
      EditConvenioComponent,
      {
        class: 'modal-md',
        ignoreBackdropClick: true,
        initialState: {
          convenio: UpdateConvenioDto.fromJS(entity.toJSON())
        }
      }
    );

    editModal.content.onSave.subscribe(() => {
      abp.notify.success("Convênio atualizado com sucesso!");
      this.onRefresh.emit();
    });
  }

  protected delete(entity: ConvenioDto): void {
    const deleteModal = this._modalService.show(
      SuspendConvenioComponent,
      {
        class: 'modal-lg',
        ignoreBackdropClick: true,
        initialState: {
          convenio: entity
        }
      }
    );

    deleteModal.content.onSave.subscribe(() => {
      abp.notify.success("Convênio suspenso com sucesso!");
      this.onRefresh.emit();
    });
  }

  protected active(entity: ConvenioDto): void {
    const activeModal = this._modalService.show(
      ActiveConvenioComponent,
      {
        class: 'modal-lg',
        ignoreBackdropClick: true,
        initialState: {
          convenio: entity
        }
      }
    );

    activeModal.content.onSave.subscribe(() => {
      abp.notify.success("Convênio ativado com sucesso!");
      this.onRefresh.emit();
    });
  }

  protected checkStatus(value: boolean) {
    this.status = value;
    this.onStatus.emit(this.status);
    this.onRefresh.emit();
  }

  protected checkModalidade(value: boolean) {
    this.modalidade = value;
    this.onModalidade.emit(this.modalidade);
    this.onRefresh.emit();
  }

  protected limparFiltroModalidade() {
    this.modalidade = undefined;
    this.onModalidade.emit(this.status);
    this.onRefresh.emit();
  }

  protected limparFiltroStatus() {
    this.status = undefined;
    this.onStatus.emit(this.status);
    this.onRefresh.emit();
  }

  protected getDataPage(event) {
    this.onGetDataPage.emit(event)
  }

  protected refresh() {
    this.onNameOrCnpj.emit(this.nameOrCnpj);
    this.onStatus.emit(this.status);
    this.onRefresh.emit();
  }

  protected isCreateUser(convenio: ConvenioDto): boolean {
    return this.appSession.userId == convenio.creatorUserId || this.isAdmin;
  }

  protected hasVinculo(convenio: ConvenioDto): boolean {
    if (this.isProfissional)
      return convenio.profissionalSaudeConvenio.some(x => x.convenioId == convenio.id);

    else if (this.isClinica)
      return convenio.clinicaMedicaConvenio.some(x => x.convenioId == convenio.id);

    return true;
  }

  protected removeVinculo(convenio: ConvenioDto): void {
   if(this.isClinica){
      abp.ui.setBusy();
      let vinculo = convenio.clinicaMedicaConvenio.find(x => x.convenioId == convenio.id && x.clinicaMedicaId == this.appSession.clinicaId);
      this._clinicaConvenioService.removerVinculo(vinculo?.id).pipe(
        finalize(() => {
          abp.ui.clearBusy();
        })
      ).subscribe(() => {
        this.refresh();
      });
    }else if(this.isProfissional){
      abp.ui.setBusy();
      let vinculo = convenio.profissionalSaudeConvenio.find(x => x.convenioId == convenio.id && x.profissionalSaudeId == this.appSession.profissionalId);
      this._profissionalConvenio.removerVinculo(vinculo?.id).pipe(
        finalize(() => {
          abp.ui.clearBusy();
        })
      ).subscribe(() => {
        this.refresh();
      });
    }
  }

  protected createVinculo(convenio: ConvenioDto): void {
    if(this.isClinica){
      abp.ui.setBusy();
      let vinculo = new ClinicaMedicaConvenioDto();
      vinculo.clinicaMedicaId = this.appSession.clinicaId;
      vinculo.convenioId = convenio.id;
      this._clinicaConvenioService.adicionarVinculo(vinculo).pipe(
        finalize(() => {
          abp.ui.clearBusy();
        })
      ).subscribe(() => {
        this.refresh();
      });
    }else if(this.isProfissional){
      abp.ui.setBusy();
      let vinculo = new ProfissionalSaudeConvenioDto();
      vinculo.profissionalSaudeId = this.appSession.profissionalId;
      vinculo.convenioId = convenio.id;
      this._profissionalConvenio.adicionarVinculo(vinculo).pipe(
        finalize(() => {
          abp.ui.clearBusy();
        })
      ).subscribe(() => {
        this.refresh();
      });
    }
  }
}
